import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import LenisProvider from "@/components/LenisProvider";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import Archive from "@/pages/Archive";

function App() {
  return (
    <div className="App">
      <LenisProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/archive" element={<Archive />} />
          </Routes>
        </BrowserRouter>
      </LenisProvider>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
